import { ConfigPublic } from '@/common/config.public';

export interface RouteInfo {
  route: string;
  target: RouteTarget;
}

type RouteTarget = 'elysium' | 'external';

export interface PageConfig {
  readableName: string;
  analyticsGaName: string;
  analyticsAthenaName: string;
  pagePathnames: string[];
  displayPromoBar: boolean;
  defaultMeta: PageMeta;
}

export interface PageMeta {
  title: string;
  description: string;
  coverImage: string;
}

export interface RouteOptions {
  absolute?: boolean;
  query?: Record<string, string>;
}
interface RouteBuilderOptions extends RouteOptions {
  path: string;
  target: RouteTarget;
}

export const RouteBuilder = (options: RouteBuilderOptions): RouteInfo => {
  const { path, absolute, query, target } = options;

  if (!path) {
    return { route: '', target: target };
  }

  let url = path;

  if (query && Object.keys(query).length > 0) {
    const searchParams = new URLSearchParams(query);
    url = `${url}?${searchParams.toString()}`;
  }

  if (absolute) {
    url = `${ConfigPublic.AppUrl}${url}`;
  }

  return { route: url, target };
};
